var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5V14.5C18 13.67 17.33 13 16.5 13H7.5C6.67 13 6 13.67 6 14.5V19.5M9 3H12V6.5H14V3H16.5V7C16.5 7.8285 15.8285 8.5 15 8.5H8.5C7.6715 8.5 7 7.8285 7 7V3H5C3.8955 3 3 3.8955 3 5V19C3 20.1045 3.8955 21 5 21H19C20.1045 21 21 20.1045 21 19V6.415C21 6.1495 20.8945 5.8945 20.7065 5.7065L18.5 3.5",
    stroke: "#85909F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDark);
export default __webpack_public_path__ + "static/media/saveDark.ccd4077d5da816b2f6731929b8cf6089.svg";
export { ForwardRef as ReactComponent };